const KEY      = 'kickopp-challenge-progress';
const VIEW_KEY = 'kickopp-session-view';

// ── Session-view persistence ──────────────────────────────────────────────────
// Saves which view the player was on so the app can restore the exact screen
// after a browser refresh or tab close. Only challenge-flow views are restored
// automatically; plain arena restores to the action-cards step so the player
// can re-enter the trial without replaying the squad/action-card setup.

export const saveSessionView = (view) => {
  try { localStorage.setItem(VIEW_KEY, view); } catch {}
};

export const clearSessionView = () => {
  localStorage.removeItem(VIEW_KEY);
};

/**
 * Returns the view to initialise with, validated against challengeProgress.
 * Falls back to 'menu' if nothing can be safely restored.
 */
export const resolveInitialView = () => {
  try {
    const saved = localStorage.getItem(VIEW_KEY);
    if (!saved) return 'menu';

    const progress = (() => {
      try { const r = localStorage.getItem(KEY); return r ? JSON.parse(r) : null; } catch { return null; }
    })();

    // Post-match reward screens — restore only when the matching flag is set
    if (saved === 'challenge-reward'        && progress?.rewardPending === 'player-cards') return 'challenge-reward';
    if (saved === 'challenge-action-reward' && progress?.rewardPending === 'action-cards') return 'challenge-action-reward';

    // Pre-match setup screens — restore when a squad is already confirmed
    if (saved === 'challenge-action-cards'  && progress?.squad)    return 'challenge-action-cards';
    if (saved === 'challenge-squad'         && progress)           return 'challenge-squad';

    // Mid-match arena (challenge): send back to action-cards so player just clicks Start
    if (saved === 'arena' && progress?.squad) return 'challenge-action-cards';

    // All other views (menu, cards, action-cards, kickoppedia, etc.) always open at menu
    return 'menu';
  } catch {
    return 'menu';
  }
};

export const loadChallengeProgress = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveChallengeProgress = (progress) => {
  localStorage.setItem(KEY, JSON.stringify(progress));
};

export const clearChallengeProgress = () => {
  localStorage.removeItem(KEY);
};

export const createInitialProgress = ({ difficulty, boardLayout, squad, cardTypeCounts, actionCards }) => ({
  level: 1,
  difficulty,
  boardLayout,
  lives: difficulty === 'easy' ? 3 : difficulty === 'medium' ? 1 : 0,
  squad,           // array of Card_Id numbers, always length 44
  cardTypeCounts,  // immutable quota per CardType for the entire run
  actionCards,     // array of ActionCard_Id strings owned by the player
  enabledActionCards: actionCards, // subset enabled for the current match
  draftedRewardIds: [], // Card_Ids ever added via a player reward draw (excluded from future draws)
  rewardPending: false,
});
